angular.module('sharecrf.utils', []);